import { CuredApiPaths } from '../../models/enums';
import { UseMutationOptions } from '@tanstack/react-query';
import { PathWithID } from '../../models/types';
import { ApiMethods } from '../../models/enums';
import useMutation from '../useMutation';
import MutationKeys from './keys';

const useDeleteSegment = (segmentId: string, mutateOptions?: UseMutationOptions<unknown, Error>) =>
    useMutation(
        MutationKeys.DELETE_SEGMENT,
        new PathWithID(CuredApiPaths.SEGMENTS, segmentId),
        mutateOptions,
        ApiMethods.DELETE
    );

export default useDeleteSegment;
